import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { GetUnitsListApi } from '../redux/actions/Content/GetUnitsList';
import { GetProductTypesListApi } from '../redux/actions/Content/GetProductTypesList';
import { GetCategoriesListApi } from '../redux/actions/Content/GetCategoriesList';
import { AddProductAPI } from '../redux/actions/Product/AddProductAction';
import { showErrorToast, showSuccessToast } from '../helpers/SweetAlert';
import { addProductStateReset } from '../redux/slices/Product/AddProductSlice';
import { showAddButton } from '../redux/slices/Product/showAddProductButton';
import { useNavigate } from 'react-router-dom';

const Product = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    // const { setHeading } = useHeading();
    const [images, setImages] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedProductType, setSelectedProductType] = useState('');
    const [selectedUnit, setSelectedUnit] = useState('');
    const [productName, setProductName] = useState('');
    const [description, setDescription] = useState('');
    const [price, setPrice] = useState('');
    const [quantity, setQuantity] = useState('');
    const [validationErrors, setValidationErrors] = useState('');
    const { response: categoriesListResponse, error: categoriesListError, loading: categoriesListLoading } = useSelector((state) => state.getCategoriesList);
    const { response: ProductsListResponse, error: ProductsListError, loading: ProductsListLoading } = useSelector((state) => state.getProductTypesList);
    const { response: UnitsListResponse, error: UnitsListError, loading: UnitsListLoading } = useSelector((state) => state.getUnitsList);
    const { response: AddProductResponse, error: AddProductError } = useSelector((state) => state.addProduct);

    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        const validImages = [];

        // Check if total files exceed the 10 image limit
        if (images.length + files.length > 10) {
            showErrorToast("Maximum upload limit is 10 images.");
            return;
        }

        for (let file of files) {
            if (!allowedTypes.includes(file.type)) {
                showErrorToast(`Invalid file type: ${file.name}. Only images are allowed.`);
                continue;
            }

            if (file.size > 2 * 1024 * 1024) {
                showErrorToast(`File ${file.name} exceeds 2MB size limit.`);
                continue;
            }

            validImages.push(
                file
            );
        }

        updateImages(validImages);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files);
        updateImages(files);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const updateImages = (files) => {
        // const imageFiles = files.filter(file =>
        //     ['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/svg+xml', 'image/webp'].includes(file.type)
        // );

        const newPreviews = files.map(file => ({
            file,
            url: URL.createObjectURL(file),
        }));

        setImages(prev => [...prev, ...newPreviews].slice(0, 10)); // Max 10 images
    };
    const handleRemoveImage = (indexToRemove) => {
        setImages((prev) => prev.filter((_, index) => index !== indexToRemove));
    };

    const validateForm = () => {
        const newErrors = {};

        if (!selectedCategory) newErrors.category = true;
        if (!productName.trim()) newErrors.name = true;
        if (!description.trim()) newErrors.description = true;
        if (!selectedProductType) newErrors.productType = true;
        if (!price) newErrors.price = true;
        if (!quantity) newErrors.quantity = true;
        if (!selectedUnit) {
            newErrors.unitType = true;
            newErrors.perUnit = true;
        }

        setValidationErrors(newErrors);

        return Object.keys(newErrors).length === 0; // true if no errors
    };


    const handleSubmit = async () => {
        if (!validateForm()) {
            return;
        }
        const formData = new FormData();

        // Append each image file
        images.forEach((imgObj, index) => {
            formData.append('images', imgObj.file); // Your backend expects req.files
        });

        // Append text data
        formData.append('category', selectedCategory);
        formData.append('name', productName);
        formData.append('description', description);
        formData.append('productType', selectedProductType);
        formData.append('price', price);
        formData.append('unitType', selectedUnit);
        formData.append('quantity', quantity);
        formData.append('perUnit', selectedUnit); // or separate if different

        try {
            dispatch(AddProductAPI(formData))
        } catch (error) {
            console.error('Error submitting form:', error);
        }
    };
    const resetFormFields = () => {
        setImages([]);
        setSelectedCategory('');
        setSelectedProductType('');
        setSelectedUnit('');
        setProductName('');
        setDescription('');
        setPrice('');
        setQuantity('');
        setValidationErrors('');
    };

    // useEffect(() => {
    //     setHeading('Add new product')
    // }, [])

    useEffect(() => {
        dispatch(GetUnitsListApi());
        dispatch(GetProductTypesListApi());
        dispatch(GetCategoriesListApi());
    }, [])

    useEffect(() => {
        if (AddProductResponse?.status === true) {
            showSuccessToast(AddProductResponse?.message);
            resetFormFields();
            dispatch(addProductStateReset());
            navigate('/admin-dashboard/product-management');
            // dispatch(showAddButton(false))
        }
    }, [AddProductResponse])

    useEffect(() => {
        if (AddProductError) {
            showErrorToast(AddProductError?.data);
            dispatch(addProductStateReset())
        }
    }, [AddProductError])

    return (

        (
            <div className='content_section' >
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-10'>
                            <div className='row gy-4'>
                                <div className='col-md-6'>
                                    <div className='input_wrapper'>
                                        <label>Category</label>
                                        <div className='form_field'>
                                            <select className={`form-select ${validationErrors.category ? 'is-invalid' : ''}`} value={selectedCategory}
                                                onChange={(e) => {
                                                    setSelectedCategory(e.target.value);
                                                    if (validationErrors.category) {
                                                        setValidationErrors(prev => ({ ...prev, category: false }));
                                                    }
                                                }}>
                                                {(categoriesListError || categoriesListLoading) ? (
                                                    <option>Nothing to show</option>
                                                ) : (
                                                    <>
                                                        <option>Select Category</option>
                                                        {categoriesListResponse?.data?.map((category, index) => (
                                                            <option key={index} value={category._id}>
                                                                {category.name}
                                                            </option>
                                                        ))}
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='input_wrapper'>
                                        <label>Product name</label>
                                        <div className='form_field'>
                                            <input type='text' className={`form-control ${validationErrors.name ? 'is-invalid' : ''}`} placeholder='Enter name' value={productName} onChange={(e) => {
                                                const value = e.target.value;
                                                if (value.length === 1 && value === ' ') return;
                                                setProductName(value);
                                                if (validationErrors.name) {
                                                    setValidationErrors(prev => ({ ...prev, name: false }));
                                                }
                                            }} />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='input_wrapper'>
                                        <label>Upload Images</label>
                                        <div className='form_field form_field_upload' onDrop={handleDrop}
                                            onDragOver={handleDragOver}>
                                            <input type="file" className='d-none' id='uploadImg' multiple onChange={handleFileChange} accept="image/jpeg, image/png, image/jpg, image/webp, image/svg+xml" />
                                            <label htmlFor='uploadImg'>
                                                <span><img src='/assets/icons/upload-icon.svg' /></span>
                                                <span>Drag or drop here</span>
                                                <span>or</span>
                                                <span className='primary_text'>Browse</span>
                                            </label>
                                        </div>
                                        <span className="required_info">Maximum 2MB image size and only accepted jpeg, png, jpg, gif, svg, webp Maximum upload limit is 10.</span>
                                        <div className='image-preview-list mt-3 d-flex flex-wrap gap-2'>
                                            {images.map((img, index) => (
                                                <div key={index} className='preview-img-box position-relative'>
                                                    <img
                                                        src={img.url}
                                                        alt={`preview-${index}`}
                                                        style={{
                                                            width: '80px',
                                                            height: '80px',
                                                            objectFit: 'cover',
                                                            borderRadius: '8px',
                                                            border: '1px solid #ddd',
                                                        }}
                                                    />
                                                    <button
                                                        type='button'
                                                        onClick={() => handleRemoveImage(index)}
                                                        style={{
                                                            position: 'absolute',
                                                            top: '-6px',
                                                            right: '-6px',
                                                            backgroundColor: '#fff',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '50%',
                                                            width: '20px',
                                                            height: '20px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontSize: '12px',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        &times;
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='input_wrapper'>
                                        <label>Description</label>
                                        <div className='form_field'>
                                            <textarea className={`form-control ${validationErrors.description ? 'is-invalid' : ''}`} placeholder='Enter Description' rows={6} value={description} onChange={(e) => {
                                                const value = e.target.value;
                                                if (value.length === 1 && value === ' ') return; // block leading space
                                                setDescription(value);
                                                if (validationErrors.description) {
                                                    setValidationErrors(prev => ({ ...prev, description: false }));
                                                }
                                            }} ></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='input_wrapper'>
                                        <label>Type of products available</label>
                                        <div className='form_field'>
                                            <select className={`form-select ${validationErrors.productType ? 'is-invalid' : ''}`} value={selectedProductType} onChange={(e) => {
                                                setSelectedProductType(e.target.value);
                                                if (validationErrors.productType) {
                                                    setValidationErrors(prev => ({ ...prev, productType: false }));
                                                }
                                            }}>
                                                {(ProductsListError || ProductsListLoading) ? (
                                                    <option>Nothing to show</option>
                                                ) : (
                                                    <>
                                                        <option>Select Product Type</option>
                                                        {ProductsListResponse?.data?.map((productType, index) => (
                                                            <option key={index} value={productType._id}>
                                                                {productType.name}
                                                            </option>
                                                        ))}
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='row gx-2 gy-4'>
                                        <div className='col-md-6 col-lg-6'>
                                            <div className='input_wrapper'>
                                                <label>Price</label>
                                                <div className='form_field'>
                                                    <input type='text' className={`form-control ${validationErrors.price ? 'is-invalid' : ''}`} placeholder='Enter Price' min="0"
                                                        step="0.01" value={price} onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (value === '' || /^[0-9]*\.?[0-9]*$/.test(value)) {
                                                                setPrice(value);
                                                            }
                                                            if (validationErrors.price) {
                                                                setValidationErrors(prev => ({ ...prev, price: false }));
                                                            }
                                                            // setQuantity(value)
                                                        }} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-3 col-lg-3'>
                                            <div className='input_wrapper'>
                                                <label>Per unit</label>
                                                <div className='form_field'>
                                                    <select className={`form-select ${validationErrors.units ? 'is-invalid' : ''}`} value={selectedUnit} onChange={(e) => {
                                                        setSelectedUnit(e.target.value);
                                                        if (validationErrors.units) {
                                                            setValidationErrors(prev => ({ ...prev, units: false }));
                                                        }
                                                    }}>
                                                        <option>Select Units</option>
                                                        {(UnitsListError || UnitsListLoading) ? (
                                                            <option>Nothing to show</option>
                                                        ) : (
                                                            <>
                                                                {UnitsListResponse?.data?.map((units, index) => (
                                                                    <option key={index} value={units?.unitName}>
                                                                        {units?.unitName}
                                                                    </option>
                                                                ))}
                                                            </>
                                                        )}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-3 col-lg-3'>
                                            <div className='input_wrapper'>
                                                <label>Qty</label>
                                                <div className='form_field'>
                                                    <input type='text' className={`form-control ${validationErrors.quantity ? 'is-invalid' : ''}`} placeholder='Enter Qty' min="0" value={quantity} onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (value === '' || /^[0-9]*\.?[0-9]*$/.test(value)) {
                                                            setQuantity(value);
                                                        }
                                                        if (validationErrors.quantity) {
                                                            setValidationErrors(prev => ({ ...prev, quantity: false }));
                                                        }
                                                        // setQuantity(value)
                                                    }} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-12'>
                                    <div className='hstack gap-3 mt-4'>
                                        <button className='primary-btn' onClick={handleSubmit}>Save</button>
                                        <button className='transparent-btn' onClick={resetFormFields}>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )

    )
}

export default Product